import { render, staticRenderFns } from "./FormDepartment.vue?vue&type=template&id=560f5209&"
import script from "./FormDepartment.vue?vue&type=script&lang=js&"
export * from "./FormDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports